import { MeasurementVariant, Position } from '../../../shared/types/protocol.ts';


interface PositionRow {
    positionId: number;
    positionNumber?: string;
    symbol?: string;
    variants: {
        name: string;
        count: number | null;
    }[];
}

export function getPositionsTable(
    variants: MeasurementVariant[],
    positions: Position[],
): PositionRow[] {
    const positionMap = new Map<number, PositionRow>();

    for (const position of positions) {
        if (position.type === 'generalInspection') {
            continue;
        }

        positionMap.set(position.id, {
            positionId: position.id,
            positionNumber: position.positionNumber,
            symbol: position.symbol,
            variants: variants.map((variant) => ({
                name: variant.name,
                count: variant.positions[position.id],
            })),
        });
    }

    return Array.from(positionMap.values());
}
